import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  stateContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center',
    gap: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row'
    }
  },
  title: {
    maxWidth: 'calc(100% - 190px)'
  },

  full: {
    maxWidth: '100%'
  },
  item: {
    textTransform: 'uppercase',
    fontWeight: 500
  },
  inscriptionState: {
    display: 'flex',
    gap: theme.spacing(),
    fontWeight: 500,
    fontSize: '1rem'
  },
  stateMainContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),

    borderRadius: 10,
    backgroundColor: theme.utils.rgba(theme.palette.alt.main, 0.4),
    padding: theme.spacing(3, 5),
    '&.Accepted': {
      paddingLeft: '18%',
      [theme.breakpoints.up('md')]: {
        paddingLeft: 180
      }
    }
  },
  paymentMethodLink: {
    textDecoration: 'underline',
    fontSize: '.875rem',
    cursor: 'pointer',
    marginRight: theme.spacing()
  },
  uploadReceiptButton: {
    alignSelf: 'center',
    borderRadius: 10,
    width: 180,
    [theme.breakpoints.up('sm')]: {
      maxWidth: 200
    }
  },

  state: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'flex-start',
    [theme.breakpoints.up('md')]: {
      alignItems: 'center'
    }
  },
  saleOrderState: {
    fontWeight: 500
  },
  retryInscription: {
    alignSelf: 'center',
    marginTop: theme.spacing(2),
    width: 190,
    borderRadius: 10,
    [theme.breakpoints.up('sm')]: {
      marginTop: 0
    }
  },
  link: {
    fontWeight: 600,
    color: theme.palette.primary.main
  },
  helperText: {
    fontWeight: 500
  },
  folderButton: {
    marginLeft: theme.spacing(1.5),
    marginRight: -theme.spacing(4)
  },
  actionContainer: {
    display: 'flex',
    justifyContent: 'center'
  }
}))
